import * as yup from 'yup';

export const CreateSubjectPlanFormValidation = yup.object().shape({
    description: yup.string().required('Descrição é obrigatória'),
    objectives: yup.string().required('Objectivo é obrigatório'),
    subjectReferences: yup.string().required('Referência é obrigatória'),
    assessmentCriteria: yup.string().required('Critério de avaliação é obrigatório'),
    idSubject: yup.string().required('Disciplina é obrigatório'),
    status: yup.bool().required('obrigatório').default(true),
});